module.exports = __webpack_public_path__ + "static/home-category-280aa743ee7a7b6da573d793a87c1eb7.png";